module.exports = __webpack_public_path__ + "img/3.bf6d87e0.png";